import { Component, ViewChild, } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Http, Headers } from '@angular/http';
import { NavModalComponent } from '../core/component/NavModal.Component';
import { AdmissionFormService } from './admisformservice';
import { UserService } from '../core/service/user.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { PatternConstants } from '../shell/shared/pattern.constants';
import { IxsloaderComponent } from '../components/ixsloader/ixsloader.component';


@Component({
  selector: 'admisform',
  templateUrl: './admisform.component.html',
  styleUrls: ['./admisform.component.css']
})
export class AdmisformComponent extends NavModalComponent<any> {
  @ViewChild(IxsloaderComponent) loader: IxsloaderComponent;
  public mobilem = PatternConstants.pattern.mobile;
  step: any = 1;
  myForm: FormGroup;
  studentForm: FormGroup;
  data: any = {};
  campuslist = [];
  clientid: number = 141;
  rows = [];
  country: any;
  fathername: any;
  state: any;
  city: any;
  Address: any;
  childName: any;
  entity: any;
  phoneNo: any;
  Cellno: any;
  Email: any;
  Class: any;
  DateOfbirth: any;
  gender: any;
  relation: any;
  lbladdress: any;
  lblcontactno: any;
  lblcountry: any;
  course: any;
  RealtionTypes = [];
  contryid: number;
  loginToken: any;
  public phonem = PatternConstants.pattern.mobile;
  userName: string;
  passWord: string;
  private countryurl = 'https://sm.edu-man.com/sm/api/Country/V2/ClientCountry/'
  private stateurl = 'https://sm.edu-man.com/sm/api/State/V2/ClientState/'
  private cityurl = 'https://sm.edu-man.com/sm/api/City/V2/ClientCity/'
  private entityurl = 'https://sm.edu-man.com/sm/api/Legalentity/V2/CampusList/'
  private relationurl = 'https://sm.edu-man.com/sm/api/Relationtype/v2/'
  private courseurl = 'https://sm.edu-man.com/sm/api/SMCourse/v2/ClientCourse/'
  private genderUrl = 'https://smp.edu-man.com/sm/api/lov/v2/List/GTYPE'
  private admappurl = 'https://sm.edu-man.com/sm/api/FOAdmEnquiry/v2'
  private reqsessionurl = 'https://smp.edu-man.com/sm/api/SMBatch/v2/ActiveBatch'
  private reqclassurl = 'https://smp.edu-man.com/sm/api/SMCourse/v2/CourseAgainstAdmRegister'
  private nationalityurl = 'https://smp.edu-man.com/sm/api/Country/v2/'
  private loginURL = 'https://uta.edu-man.com/ut/api/utuser/v2/loginV3';
  private stofUrl = 'https://smp.edu-man.com/sm/api/lov/v2/List/STOF'
  // private countryurl = 'http://192.168.1.117:4324/sm/api/Country/V2/ClientCountry/';
  // private stateurl = 'http://192.168.1.117:4324/sm/api/State/V2/ClientState/'
  // private cityurl = 'http://192.168.1.117:4324/sm/api/City/V2/ClientCity/';
  // private entityurl = 'http://192.168.1.117:4324/sm/api/Legalentity/V2/CampusList/';
  // private relationurl ='http://192.168.1.117:4324/sm/api/Relationtype/v2/';
  // private courseurl = 'http://192.168.1.117:4324/sm/api/SMCourse/v2/ClientCourse/';
  // private genderUrl = 'http://192.168.1.117:4324/sm/api/lov/v2/List/GTYPE'
  // private admappurl = 'http://192.168.1.117:4324/sm/api/FOAdmEnquiry/v2/';

  constructor(
    private admissionFormService: AdmissionFormService,
    private _httpClient: Http,
    private userService: UserService,
  ) {
    super(admissionFormService);
    // this.getData().subscribe((i: ConstantClass) => {
    //   
    //   if (
    //     i.Clients.length > 0 &&
    //     i.Clients.filter((o) => o.hostname === window.location.hostname)[0]
    //   ) {
    //     let obj = i.Clients.filter(
    //       (o) => o.hostname === window.location.hostname
    //     )[0];

    //     
    //     if (obj && Number(obj.Id) > 0) {
    //       this.clientid = Number(obj.Id);
    //     }
    //     this.localStorage.set("clientid", obj.Id)

    //     if(obj != null) {
    //       this.userName = obj.username,
    //       this.passWord = obj.password
    //     }
    //     


    //   }

    // });

  }

  async ngOnInit() {
    this.initializeForm();
    // if(this.userName != null && this.passWord !=null && this.clientid != null){
    //   
    //   let username = this.userName;
    //   let password = this.passWord;
    //   let clientid = this.clientid;
    //   await  this.login(username , password , clientid);
    //   
    // }
    // await this.login("edumanin", "eduixs@@123", 141)
    await this.getgenders();
    await this.getRequiredSession();
    await this.getNationality();
    await this.getTransferType();
    await this.loginUser("edumanin", "eduixs@@123", 160);

  }

  initializeForm() {

    this.myForm = this.fb.group({
      stdname: ['', []],
      noofsib: [0, []],
      stdCPR: ['', []],
      stdDbo: ['', []],
      genderid: ['', []],
      sessionId: ['', []],
      classId: ['', []],
      nationalityId: ['', []],
      prvSchool: ['', []],
      fathername: ['', []],
      fatherCPR: ['', []],
      phone: ['00973', []],
      contactNo: ['00973', []],
      fathercellno: ['00973', []],
      lovstdtrans: ['', [Validators.required]],
      email: ['', [Validators.required]],
    })

  }

  public getData(): Observable<any> {

    const a = this._httpClient
      .get("../../assets/IXS/resultJSON.json")
      .map((res: any) => {
        return res.json();
      });
    return a;
  }

  getInfo() {

    if (this.data) {

      this.fathername = this.data.name,
        this.Cellno = this.data.cellno,
        this.phoneNo = this.data.phoneno,
        this.Email = this.data.email,
        this.Address = this.data.address

    }

  }

  increment() {
    this.myForm.controls['noofsib'].setValue(Number(this.myForm.controls['noofsib'].value) + 1);
  }

  decrement() {
    if (this.myForm.controls['noofsib'].value > 0) {
      this.myForm.controls['noofsib'].setValue(Number(this.myForm.controls['noofsib'].value) - 1);
    }
  }


  // async login( username, password){
  //   
  //   var obj = {
  //     data: {
  //         user: {
  //             "Username": username,
  //             "Password": password
  //         }
  //     }
  //  }

  //  var baseurl = "http://ut.edu-man.com:4323/ut/api/utuser/v2/loginV3";

  //  const headers = new Headers({
  //    'content-type': 'application/json',
  //    'content-lenght':'<calculated when request is sent>',
  //    data: JSON.stringify(obj)
  //  });
  //  
  //  this._httpClient.put(baseurl , obj ,{headers : headers}).subscribe((res) =>{

  //   if(res == null){
  //       console.log("wrong username and password")
  //   }

  //   else{
  //     this.loginToken = res.z;
  //   }
  //   

  //  },err =>{
  //       console.log("Erro with api")
  //  })
  //  
  // }


  async login(username: string, password: string, clientid: any) {


    var dto = await this.userService.login(
      username,
      password,
      clientid,

    );


    if (dto && dto.Data && dto.Data.Session) {
      this.localStorage.set("token", "bearer ".concat(dto.Data.Session.token));

      this.loginToken = dto.Data.Session.token;
      localStorage.setItem("token", `${this.loginToken}`);
    }
    if (dto && dto.IsSuccess) {
      await this.getCountryClient(this.clientid);
      await this.getrelation();
      await this.getgenders();
    }
  }

  addItem() {

    let Courseid = this.studentForm.controls['courseid'].value
    let Dob = this.studentForm.controls['dob'].value
    let Genderid = this.studentForm.controls['genderid'].value;
    // let classId = this.studentForm.controls['classId'].value;
    // let sessionId = this.studentForm.controls['sessionId'].value;
    let Childname = this.studentForm.controls['childname'].value;

    if (!Courseid || !Dob || !Childname || !Genderid) {

      Swal.fire({

        title: 'Error!',
        text: 'Please provide proper info of student!',
        icon: 'error',
        confirmButtonText: 'Ok'

      });
    }

    else if (Dob) {
      var dateString = this.studentForm.controls['dob'].value;
      var myDate = new Date(dateString).toDateString();
      var today = new Date().toDateString();
      if (new Date(myDate) >= new Date(today)) {

        Swal.fire({
          title: 'Error!',
          text: 'Date of birth cannot be Equal to the current date!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
        return false;

      } else {
        let record = {

          Courseid: Courseid != undefined ? Courseid : '',
          Dob: Dob != undefined ? Dob : '',
          Genderid: Genderid != undefined ? Genderid : '',
          Childname: Childname != undefined ? Childname : '',
        };
        this.rows.push(record);
        this.studentForm.reset();
      }
    }

  }

  removeItem(element) {

    this.rows.forEach((value, index) => {
      if (value == element)
        this.rows.splice(index, 1);
    });
  }



  nextButton() {

    if (this.step == 1) {
      if (!this.myForm.controls['countryid'].value || !this.myForm.controls['stateid'].value || !this.myForm.controls['cityid'].value || !this.myForm.controls['entityid'].value) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide campus info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.step++;
      }
    }

    else if (this.step == 2) {
      if (!this.myForm.controls['relationtypeid'].value || !this.myForm.controls['name'].value || !this.myForm.controls['cellno'].value || !this.myForm.controls['address'].value || !this.myForm.controls['noofchild'].value) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide guardian info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.step++;
      }

      this.setValues();
    }

    else if (this.step == 3) {
      if (this.rows && this.rows.length == 0) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide student info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.data = this.myForm.value;
        this.getInfo();
        this.step++;
      }
    }
  }
  prevButton() {
    this.step--;
  }

  async onSubmit() {

    if (this.rows && this.rows.length && this.rows.length > 0) {
      this.data.FOAdmEnquirydtls = this.rows;
    }
    await this.postAdmissionForm();

  }


  async getCountryClient(clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    var url = this.countryurl + this.clientid
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.country = dto.Data;

    }, err => {
      console.log("something went wrong with service" + err)
    });

  }

  async getState(countryid, clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };


    this.contryid = this.myForm.controls['countryid'].value;
    var url = this.stateurl + this.contryid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.state = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })




  }

  async getCity(countryid, stateid, clientid) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    this.contryid = this.myForm.controls['countryid'].value;
    var stateid = this.myForm.controls['stateid'].value;
    var url = this.cityurl + this.contryid + '/' + stateid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.city = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })
  }
  async getEntities(countryid, stateid, cityid, clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    this.contryid = this.myForm.controls['countryid'].value;
    var stateid = this.myForm.controls['stateid'].value;
    var cityid = this.myForm.controls['cityid'].value;
    var url = this.entityurl + this.contryid + '/' + stateid + '/' + cityid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.entities = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })

  }

  async getrelation() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    this._httpClient.get(this.relationurl, requestOptions).subscribe((res) => {
      const dto = res.json();
      this.LookupData.relations = dto.Data;
    })

  }

  async getCourse(entityid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    var entityid = this.myForm.controls['entityid'].value
    var url = this.courseurl + entityid
    this._httpClient.get(url, requestOptions).subscribe((res) => {
      const dto = res.json();
      this.LookupData.courses = dto.Data;
    }, err => {
      console.log("something went wrong with service")
    });

  }

  async getgenders() {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };


    this._httpClient.get(this.genderUrl, requestOptions).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        this.LookupData.Genders = dto.Data;
      }
    });


  }

  async getTransferType() {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };


    this._httpClient.get(this.stofUrl, requestOptions).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        this.LookupData.TransferTypes = dto.Data;
      }
    });


  }

  async Modelchange(entityId) {
    await this.getRequiredClasses(entityId);
  }
  async getRequiredSession() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Authorization", "bearer " + this.loginToken);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    this._httpClient.get(`${this.reqsessionurl}/5030/0`, requestOptions).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        this.LookupData.Sessions = dto.Data;
      }
    });
  }

  async loginUser(email, password, clientId) {
    const payload = {
      Data: {
        User: {
          password: password,
          userclientid: clientId,
          username: email
        }
      }
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    this._httpClient.put('https://utp.edu-man.com/ut/api/utuser/v2/loginV3', payload, { headers: myHeaders }).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        this.LookupData.loginResponse = dto.Data;
      }
      console.log(this.LookupData, 'LookupData');
    });
  };

  allowOnlyNumbers(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    // Allow only numeric keys (0-9)
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  validateForm(): boolean {
    let isValid = true;
    const errors: string[] = [];

    // Validate required fields
    if (!this.myForm.controls['stdname'].value) {
      errors.push('Student name is required');
      isValid = false;
    }

    if (!this.myForm.controls['stdDbo'].value) {
      errors.push('Date of birth is required');
      isValid = false;
    } else {
      // Validate date of birth
      const dob = new Date(this.myForm.controls['stdDbo'].value);
      const today = new Date();
      if (dob >= today) {
        errors.push('Date of birth cannot be today or in the future');
        isValid = false;
      }
    }

    if (!this.myForm.controls['genderid'].value) {
      errors.push('Gender is required');
      isValid = false;
    }

    if (!this.myForm.controls['sessionId'].value) {
      errors.push('Session is required');
      isValid = false;
    }

    if (!this.myForm.controls['classId'].value) {
      errors.push('Class is required');
      isValid = false;
    }

    if (!this.myForm.controls['nationalityId'].value) {
      errors.push('Nationality is required');
      isValid = false;
    }

    if (!this.myForm.controls['fathername'].value) {
      errors.push('Father name is required');
      isValid = false;
    }

    if (!this.myForm.controls['lovstdtrans'].value) {
      errors.push('Student Transfer Options is required');
      isValid = false;
    }

    if (!this.myForm.controls['email'].value) {
      errors.push('Email is required');
      isValid = false;
    } else {
      const email = this.myForm.controls['email'].value;
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailPattern.test(email)) {
        errors.push('Please enter a valid email address');
        isValid = false;
      }
    }

    // Validate contact number with pattern (assuming 8 digits for Bahrain)
    const contactNo = this.myForm.controls['contactNo'].value;
    const contactNoDigits = contactNo ? contactNo.replace(/\D/g, '').trim() : '';
    if (!contactNo || contactNoDigits === '') {
      errors.push('Contact number is required');
      isValid = false;
    } else if (contactNoDigits.length !== 13) {
      errors.push('Contact number must be 13 digits long');
      isValid = false;
    }

    // Validate father's contact number with pattern
    const phone = this.myForm.controls['phone'].value;
    const phoneDigits = phone ? phone.replace(/\D/g, '').trim() : '';
    if (!phone || phoneDigits === '') {
      errors.push('Father Number is required');
      isValid = false;
    } else if (phoneDigits.length !== 13) {
      errors.push('Father Number must be 13 digits long');
      isValid = false;
    }

    // Validate father's whatsapp number with pattern
    const fathercellno = this.myForm.controls['fathercellno'].value;
    const whatsappDigits = fathercellno ? fathercellno.replace(/\D/g, '').trim() : '';
    if (!fathercellno || whatsappDigits === '') {
      errors.push('Father WhatsApp Number is required');
      isValid = false;
    } else if (whatsappDigits.length !== 13) {
      errors.push('Father WhatsApp Number must be 13 digits long');
      isValid = false;
    }

    // Validate CPR numbers if provided
    const stdCPR = this.myForm.controls['stdCPR'].value;
    if (!stdCPR) {
      errors.push('Student CPR is required');
      isValid = false;
    } else if (stdCPR && stdCPR.length !== 9) {
      errors.push('Student CPR must be 9 digits long');
      isValid = false;
    }

    const fatherCPR = this.myForm.controls['fatherCPR'].value;
    if (!fatherCPR) {
      errors.push('Father CPR is required');
      isValid = false;
    } else if (fatherCPR && fatherCPR.length !== 9) {
      errors.push('Father CPR must be 9 digits long');
      isValid = false;
    }

    if (!isValid) {
      Swal.fire({
        title: 'Error',
        html: errors.join('<br>'),
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    }

    return isValid;
  }


  async submitForm() {
    // this.startLoading();

    if (!this.validateForm()) {
      return;
    }

    const now = new Date();
    const bahrainDateTime = now.toLocaleString('en-US', {
      timeZone: 'Asia/Bahrain',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true  // Enable AM/PM
    });

    const dateParts = bahrainDateTime.split(', ');
    const timeParts = dateParts[1] ? dateParts[1].split(' ') : dateParts[0].split(' ');

    let dateStr, timeStr, ampm;

    if (dateParts[1]) {
      // Format: "MM/DD/YYYY, HH:MM:SS AM"
      dateStr = dateParts[0];
      const timeAndAmPm = dateParts[1].split(' ');
      timeStr = timeAndAmPm[0];
      ampm = timeAndAmPm[1];
    } else {
      // Format: "MM/DD/YYYY HH:MM:SS AM"
      const timeAndAmPm = timeParts[2] ? [timeParts[1], timeParts[2]] : [timeParts[1], ''];
      dateStr = timeParts[0];
      timeStr = timeAndAmPm[0];
      ampm = timeAndAmPm[1];
    }

    // Convert MM/DD/YYYY to YYYY-MM-DD
    const [month, day, year] = dateStr.split('/');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    // Create final datetime string with AM/PM
    const enquirydate = `${formattedDate} ${timeStr} ${ampm}`;

    const payload = {
      Data: {
        // noofsib: this.myForm.controls['noofsib'].value,
        // stdCPR: this.myForm.controls['stdCPR'].value,
        // stdDbo: this.myForm.controls['stdDbo'].value,
        // sessionId: this.myForm.controls['sessionId'].value,
        // classId: this.myForm.controls['classId'].value,
        // nationalityId: this.myForm.controls['nationalityId'].value,
        // prvSchool: this.myForm.controls['prvSchool'].value,
        // fathername: this.myForm.controls['fathername'].value,

        FOAdmEnquirydtls: [{
          genderid: this.myForm.controls['genderid'].value,
          childname: this.myForm.controls['stdname'].value,
          courseid: this.myForm.controls['classId'].value,
          dob: this.myForm.controls['stdDbo'].value,
        }],
        nationalityid: this.myForm.controls['nationalityId'].value,
        prevschoolname: this.myForm.controls['prvSchool'].value,
        studentcpr: this.myForm.controls['stdCPR'].value,
        noofsiblings: this.myForm.controls['noofsib'].value,
        fatherCPR: this.myForm.controls['fatherCPR'].value,
        phone: this.myForm.controls['phone'].value,
        noofchild: 1,
        enquiryno: "",
        enquirydate: enquirydate,
        relationtypeid: 1,
        name: this.myForm.controls['fathername'].value,
        address: null,
        cellno: this.myForm.controls['contactNo'].value,
        email: this.myForm.controls['email'].value,
        entityid: 5030,
        sourcetypeid: 3501,
        description: "",
        assignto: 42046,
        followupdate: null,
        nextfollowup: null,
        note: null,
        resptypeid: null,
        statusid: null,
        followup: null,
        id: null,
        batchid: this.myForm.controls['sessionId'].value,
        testdate: null,
        picktime: null,
        droptime: null,
        imageid: null,
        acdyearid: null,
        flatno: null,
        roadno: null,
        blockno: null,
        area: null,
        buildingno: null,
        fathercellno: this.myForm.controls['fathercellno'].value,
        lovstdtrans: this.myForm.controls['lovstdtrans'].value
      }
    }




    console.log(payload, 'payload')


    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.LookupData.loginResponse.Session.token);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: JSON.stringify(payload),
    };

    this.loader.startLoading();
    this._httpClient.post('https://smp.edu-man.com/sm/api/FOAdmEnquiry/v2/', payload, { headers: myHeaders }).subscribe((res: any) => {

      if (res.status === 200) {
        this.loader.stopLoading();
        const dto = JSON.parse(res._body);
        this.LookupData.Classes = dto.Data;
        Swal.fire({
          title: 'Success',
          html: `
            <div style="text-align: left; font-size: 14px;">
              <p>Registration Successful!</p>
              <hr>
              <p><strong>Documents Required for Admission</strong></p>
              <p><em>From Grades 2 and Above:</em></p>
              <ol>
                <li>Original School Leaving Certificate and Original Recent Result Card. (For students coming from abroad, attestation is required from the relevant Ministry of Foreign Affairs (MOFA) in their home country, the embassy of the relevant country in Bahrain, and MOFA in Bahrain).</li>
              </ol>
              <p><strong>Required Documents for Admission for All Classes:</strong></p>
              <ol>
                <li>Valid color copies of CPR (for the student, father, and mother).</li>
                <li>Valid color copies of the passport and residence permit (for the student, father, and mother).</li>
                <li>Copy of the birth certificate (for the student).</li>
                <li>Copy of the vaccination record (for the student).</li>
              </ol>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Ok'
        });
        this.myForm.reset();
      }
    }, err => {
      this.loader.stopLoading();
      if (err._body) {
        const errordesc = JSON.parse(err._body);
        const errorMessage = errordesc.Errors && errordesc.Errors.length > 0 ? errordesc.Errors[0].Description : 'Registration failed';

        Swal.fire({
          title: 'Error!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }


    });
  };

  async getRequiredClasses(batchId) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Authorization", "bearer " + this.loginToken);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    this._httpClient.get(`${this.reqclassurl}/5030/${batchId || 0}`, requestOptions).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        this.LookupData.Classes = dto.Data;
      }
    });
  }

  async getNationality() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    // myHeaders.append("Authorization", "bearer " + this.loginToken);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    this._httpClient.get(this.nationalityurl, requestOptions).subscribe((res: any) => {
      if (res.status === 200) {
        const dto = JSON.parse(res._body);
        console.log(dto.Data, 'national')
        this.LookupData.NationalityLst = dto.Data;
      }
    });
  }

  setValues() {

    if (this.LookupData.entities && this.LookupData.entities.length > 0) {
      var ab = this.LookupData.entities.filter(w => w.entityid === this.myForm.controls['entityid'].value)[0];
      if (ab) {
        this.lbladdress = ab.address;
        this.lblcontactno = ab.contactno;
        this.entity = ab.stxt
      }


      if (this.LookupData.country && this.LookupData.country.length > 0)
        var ab = this.LookupData.country.filter(w => w.Id === this.myForm.controls['countryid'].value)[0];
      if (ab) {
        this.country = ab.countryname;

      }

      if (this.LookupData.state && this.LookupData.state.length > 0)
        var ab = this.LookupData.state.filter(w => w.Id === this.myForm.controls['stateid'].value)[0];
      if (ab) {
        this.state = ab.stxt;
      }

      if (this.LookupData.city && this.LookupData.city.length > 0)
        var ab = this.LookupData.city.filter(w => w.Id === this.myForm.controls['cityid'].value)[0];
      if (ab) {
        this.city = ab.citystxt;
      }

      if (this.LookupData.relations && this.LookupData.relations.length > 0)

        var ab = this.LookupData.relations.filter(w => w.Id === this.myForm.controls['relationtypeid'].value)[0];
      if (ab) {
        this.relation = ab.stxt;
      }



      // if (this.LookupData.course && this.LookupData.course.length > 0)
      //   var ab = this.LookupData.course.filter(w => w.Id === this.myForm.controls['courseid'].value)[0];
      // if (ab) {
      //   this.course = ab.stxt;

      // }

      // if (this.LookupData.Genders && this.LookupData.Genders.length > 0)
      //   var ab = this.LookupData.Genders.filter(w => w.Id === this.myForm.controls['genderid'].value)[0];
      // if (ab) {
      //   this.gender = ab.stxt;

      // }

    }

  }

  async postAdmissionForm() {
    var dto = {
      Data: {
        relationtypeid: this.myForm.controls['relationtypeid'].value,
        name: this.myForm.controls['name'].value,
        address: this.myForm.controls['address'].value,
        phoneno: this.myForm.controls['phoneno'].value,
        cellno: this.myForm.controls['cellno'].value,
        entityid: this.myForm.controls['entityid'].value,
        resptypeid: this.myForm.controls['resptypeid'].value,
        sourcetypeid: this.myForm.controls['sourcetypeid'].value,
        followupdate: this.myForm.controls['followupdate'].value,
        nextfollowup: this.myForm.controls['nextfollowup'].value,
        noofchild: this.myForm.controls['noofchild'].value,
        FOAdmEnquirydtls: this.rows
      }
    }

    const headers = new Headers({
      'content-type': 'application/json',
      'content-lenght': '<calculated when request is sent>',
      'authorization': "bearer " + this.loginToken
    });
    var url = this.admappurl;
    this._httpClient.post(url, dto, { headers: headers })
      .subscribe(res => {

        Swal.fire({
          title: 'Good job!',
          html: `
            <div style="text-align: left; font-size: 14px;">
              <p>Admission registration successful!</p>
              <hr>
              <p><strong>Documents Required for Admission</strong></p>
              <p><em>From Grades 2 and Above:</em></p>
              <ol>
                <li>Original School Leaving Certificate and Original Recent Result Card. (For students coming from abroad, attestation is required from the relevant Ministry of Foreign Affairs (MOFA) in their home country, the embassy of the relevant country in Bahrain, and MOFA in Bahrain).</li>
              </ol>
              <p><strong>Required Documents for Admission for All Classes:</strong></p>
              <ol>
                <li>Valid color copies of CPR (for the student, father, and mother).</li>
                <li>Valid color copies of the passport and residence permit (for the student, father, and mother).</li>
                <li>Copy of the birth certificate (for the student).</li>
                <li>Copy of the vaccination record (for the student).</li>
              </ol>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Ok'
        })
        this.myForm.reset();
        this.step = 1;

        this.fathername = undefined;
        this.country = undefined;
        this.entity = undefined;
        this.city = undefined;
        this.state = undefined;
        this.relation = undefined;
        this.lbladdress = undefined;
        this.lblcontactno = undefined;
        this.Cellno = undefined;
        this.phoneNo = undefined;
        this.Email = undefined;
        this.Address = undefined;
        this.rows = [];

      }, err => {

        Swal.fire({
          title: 'Error!',
          text: 'Admission registration unsuccessful!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })


      });
  }

}
export class ConstantClass {
  Clients: Clients[];
}

interface Clients {
  Id: Number;
  code: string;
  name: string;
  description: string;
  hostname: string;
  filename: string;
  height: any;
  width: any;
  username: string;
  password: string;
}















// WEBPACK FOOTER //
// ./src/app/admisform/admisform.component.ts